// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * 带进度查询分页
 * @param params
 * @returns {*}
 */
export function pageWithProgress(params) {
  return axios.get('/loveq/audio/progress/page', {params: params}).then(res => res.data);
}
/**
 * 根据id查询进度
 * @returns {*}
 */
export function getProgressByAudioId(audioId) {
  return axios.get('/loveq/audio/progress/getProgressByAudioId/' + audioId).then(res => res.data);
}
/**
 * 更新进度
 * @returns {*}
 */
export function sendUpdateProgress(audioId, params) {
  return axios.get('/loveq/audio/progress/updateProgressByAudioId/' + audioId, {params: params}).then(res => res.data);
}
/**
 * 按年份查询节目数
 * @param params
 * @returns {*}
 */
export function countByYear(params) {
  return axios.get('/loveq/audio/countByYear', {params: params}).then(res => res.data);
}
/**
 * 拉取节目
 * @param params
 * @returns {*}
 */
export function pull(params) {
  return axios.get('/loveq/audio/pull', {params: params}).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/loveq.js